import styled from 'styled-components';

export const HiddenSubmitButton = styled.button`
    display: none;
`


// WEBPACK FOOTER //
// ./src/components/FilterNav/styled.js